interface CalculatedData {
  fscore: number;
  escore: number;
  cqs: number;
  cre: number;
  cash_flow: number;
  earnings_volatility: number;
  interest_cover: number;
  leverage: number;
  profitability: number;
  size: number;
  credit_risk_level: string;
}

interface Percentage {
  cash_flow_pct: number;
  earnings_volatility_pct: number;
  interest_cover_pct: number;
  leverage_pct: number;
  profitability_pct: number;
  size_pct: number;
}

interface OriginalValues {
  leverage: number;
  leverage_pct: number;
  interest_cover: number;
  interest_cover_pct: number;
  profitability: number;
  profitability_pct: number;
  cash_flow: number;
  cash_flow_pct: number;
  earnings_volatility: number;
  earnings_volatility_pct: number;
  total_assets: number;
  total_assets_pct: number;
  market_leverage: number;
  market_leverage_pct: number;
  idio_vol: number;
  idio_vol_pct: number;
  alpha: number | null;
  alpha_pct: number | null;
}

export interface CalculatedFundamentals {
  calculated_data: CalculatedData;
  pct: Percentage;
  original_values: OriginalValues;
  aux: Record<string, any>;
  err_msg: string;
  err_code: number;
  status: number;
}

export const CalculatedValuesRows = [
  {
    key: 'size',
    label: 'Total Assets (mn)',
    tooltip: "Total Assets has a positive impact on a company's CSR (1 = worst, 100 = best)",
    hidden: false,
  } as const,
  {
    key: 'leverage',
    label: 'Leverage (%)',
    tooltip: "Leverage has a negative impact on a company's CSR (1 = best, 100 = worst)",
    hidden: false,
  } as const,
  {
    key: 'interest_cover',
    label: 'Interest Coverage',
    tooltip: "Interest Coverage has a positive impact on a company's CSR (1 = worst, 100 = best)",
    hidden: false,
  } as const,
  {
    key: 'cash_flow',
    label: 'Cash Flow',
    tooltip: "Cash Flow has a positive impact on a company's CSR (1 = worst, 100 = best)",
    hidden: false,
  } as const,
  {
    key: 'earnings_volatility',
    label: 'Earnings Vol (%)',
    tooltip: "Earnings Vol has a negative impact on a company's CSR (1 = best, 100 = worst)",
    hidden: false,
  } as const,
  {
    key: 'profitability',
    label: 'Profitability (%)',
    tooltip: "Profitability has a positive impact on a company's CSR (1 = worst, 100 = best)",
    hidden: false,
  } as const,
  {
    key: 'market_leverage',
    label: 'Market Leverage (%)',
    tooltip: "Market Leverage has a negative impact on a company's CSR (1 = best, 100 = worst)",
    hidden: false,
  } as const,
  {
    key: 'idio_vol',
    label: 'Idiosyncratic Vol (%)',
    tooltip: "Implied Market Leverage has a negative impact on a company's CSR (1 = best, 100 = worst)",
    hidden: false,
  } as const,
] as const;

type CalculatedValuesRowsKeys = (typeof CalculatedValuesRows)[number]['key'];

export interface CalculatedFundamentalsTable {
  type: CalculatedValuesRowsKeys;
  label: string;
  original: {
    value: number | undefined;
    percentage: number | undefined;
    tooltip: string | undefined;
  };
  modified: {
    value: number | undefined;
    percentage: number | undefined;
  };
}
